import { PageHeader, Row, Col, Button, Tag, Typography, Tooltip, Card, Image, Skeleton } from "antd";
import { Fragment, useEffect, useState } from "react";
import TabsLayout from "../../shared/layouts/tabs.layout";
import { useMediaQuery } from "react-responsive";
import { useDispatch } from "react-redux";
import FormBar from "../../shared/layouts/formbar.layout";
import { ReactComponent as EyeIcon } from "../../assets/icons/eye-icon.svg";
import { ReactComponent as PDFICON } from "../../assets/icons/pdficon.svg";
import { ReactComponent as NOTFOUND } from "../../assets/icons/search-image.svg";
import { getAnnouncementCategories, getUserAnnouncementList } from "../../core/store/reducers/annoucements.slice";
import moment from "moment";

function AnnouncementsPage() {
  const dispatch = useDispatch();
  const [filters, setFilters] = useState({ type: "New" } as any);
  const [listData, setListData] = useState(null as any);
  const [loading, setLoading] = useState(null as any);
  const screenType = {
    desktop: useMediaQuery({ minWidth: 992 }),
    tablet: useMediaQuery({ minWidth: 768, maxWidth: 991 }),
    mobile: useMediaQuery({ maxWidth: 767 }),
  };
  const [announcementCategories, setAnnouncementCategories] = useState(
    [] as any
  );
  var allTabs = ["New", "Past"].map((val: any) => {
    return {
      title: val,
      key: val,
      component: <></>,
    };
  });
  const onTabChange = (e: any) => {
    setFilters({ type: ["New", "Past"][e-1] });
  };
  useEffect(() => {
    filters?.type && loadList();
  }, [filters]);
  useEffect(()=>{
    dispatch(getAnnouncementCategories()).then((val: any) => {
      if (val?.payload?.data?.data) {
        setAnnouncementCategories(val?.payload?.data?.data);
      }
    });
  }, [])
  const loadList = () => {
    setLoading(true)
    let filter = {  } as any;
    if(filters?.type == 'New'){
      filter.from_date = moment().subtract(7, 'days').format('YYYY-MM-DD')
      filter.to_date = moment().format('YYYY-MM-DD')
    }
    if(filters?.type == 'Past'){
      filter.to_date = moment().subtract(7, 'days').format('YYYY-MM-DD')
    }
    if(filters?.date_range?.length == 2){
      filter.from_date = moment(filters.date_range[0]).format('YYYY-MM-DD')
      filter.to_date = moment(filters.date_range[1]).format('YYYY-MM-DD')
    }
    if(filters?.category){
      filter.category = filters.category
    }
    if(filters?.announcement_type){
      filter.announcement_type = filters.announcement_type
    }
    dispatch(
      getUserAnnouncementList({
        offset: 0,
        limit: 1000,
        // status_id: selectedStatus,
        ...filter,
        // ...sorterData,
      })
    ).then((val:any)=>{
      if(val?.payload?.data?.data?.items){
        setListData(val?.payload?.data?.data?.items)
        setLoading(false)
      }
      if(val?.payload?.data?.statusCode == 404){
        setListData([])
        setLoading(false)
      }
    })
  };
  async function filterFormSubmit(changed: any, all: any) {
    setFilters({...filters, ...all});
  }
  const formData = {
    onFinish: () => {},
    onFinishFailed: () => {},
    onValuesChange: filterFormSubmit,
    initialValues: { ...filters },
    filtersApplied: filters
      ? Object.keys(
          Object.fromEntries(
            Object.entries(filters).filter(([_, v]) => v != null)
          )
        ).length
      : 0,
    setValues: {
      ...filters,
    },
    formElements: [
      {
        type: "RangePicker",
        name: "date_range",
        allowClear: true,
        colSpan: screenType.mobile ? 12 : 4,
        disabledDate: (d:any)=>{
          if(filters?.type == "New"){
            return d > moment() || d < moment().subtract(7, 'days')
          } 
          if(filters?.type == "Past"){
            return d > moment().subtract(7, 'days')
          } 
        }
      },
      {
        type: "Select",
        name: "category",
        allowClear: true,
        colSpan: screenType.mobile ? 12 : 4,
        placeholder: "Announcement Category",
        options: announcementCategories?.map((val: any) => {
          return { name: val, value: val };
        }),
      },
      {
        type: "Select",
        name: "announcement_type",
        allowClear: true,
        colSpan: screenType.mobile ? 24 : 4,
        placeholder: "Announcement Type",
        options: [
          { name: 'Video', value: 'video' },
          { name: 'File', value: 'file' }
        ],
      },
    ],
  };
  return (
    <Fragment>
      <PageHeader
        ghost={false}
        className="pb-0"
        title={
          <Row
            style={screenType.mobile ? { paddingLeft: "25px" } : {}}
            align="middle"
          >
            <Col flex="auto" className="title-text">
              Announcements
            </Col>
          </Row>
        }
      ></PageHeader>

      <Row>
        <Col span={24} className="crm-tabs-2">
          <TabsLayout AllTabs={allTabs} onChange={onTabChange}></TabsLayout>
        </Col>
      </Row>
      {listData && <Row>
        <Col className="filters-formbar px-4" span={24}>
          <FormBar
            name={"generic_filters"}
            onFinish={formData.onFinish}
            onFinishFailed={formData.onFinishFailed}
            formElements={formData.formElements}
            initialValues={formData.initialValues}
            onValuesChange={formData.onValuesChange}
            buttonText={""}
            setValues={formData.setValues ? formData.setValues : null}
          ></FormBar>
        </Col>
      </Row>}
      {!loading && listData?.length == 0 && <Row align="middle" style={{height: '80vh'}}>
        <Col span={24}>
            <div className="not-found-area">
                <NOTFOUND />
                <p>No {filters?.type} Announcements To View</p>
            </div>
        </Col>
      </Row>}
      {loading && <>
        <Skeleton active={true} />
        <Skeleton active={true} />
        <Skeleton active={true} />
      </>}
      {!loading && listData?.length > 0 && <Row className="content-area annoucement-bg">
        <Col span={24}>
          <Row gutter={16}>
            {listData?.map((val:any)=><Col lg={8} md={12} sm={24} xs={24} className="annoucement-block pt-4">
              <h3>
                {val?.announcement_name} <Tag>{val?.announcement_category}</Tag>
              </h3>
              <Typography.Text className="sub-text"
                style={{ width: 'calc(100% - 30px)' }}
                ellipsis={{ tooltip: false }}
              >
                {val?.description}
              </Typography.Text> <Tooltip title={val?.description}><EyeIcon className="sub-text" /></Tooltip>
              <Card>
                {val?.announcement_type == 'file' && val?.filename?.split(".")[val?.filename?.split(".")?.length - 1]?.toLowerCase() == 'jpg' &&  <>
                  <Image src={val?.ref_url} height={'300px'} />
                </>}
                {val?.announcement_type == 'file' && val?.filename?.split(".")[val?.filename?.split(".")?.length - 1]?.toLowerCase() == 'pdf' &&  <>
                <a href={val?.ref_url} target="_blank"><div className="pdf-section">
                    <PDFICON />
                    <h4>{val?.filename}</h4>
                    {/* <p>Employee of the month criteria for the month of July 2023</p> */}
                </div></a>
                </>}
                {val?.announcement_type == 'video' && val?.announcement_ref?.indexOf('<iframe') !== -1 &&  <>
                  <div dangerouslySetInnerHTML={{__html: val?.announcement_ref}} /> 
                </>}
                {val?.announcement_type == 'video' && val?.announcement_ref?.indexOf('<iframe') == -1 &&  <>
                  <iframe src={val?.announcement_ref} height="300" frameBorder="0" scrolling="no" allowFullScreen></iframe>
                </>}
              </Card>
            </Col>)}
            {/* <Col lg={8} md={12} sm={24} xs={24} className="annoucement-block pt-4">
              <h3>
                FY'24 IBL Circular for TM-SBM-HBM <Tag>FAQ</Tag>
              </h3>
              <Typography.Text className="sub-text"
                style={{ width: 'calc(100% - 30px)' }}
                ellipsis={{ tooltip: false }}
              >
                Ant Design, a design language for background applications, is
                refined by Ant UED Team.
              </Typography.Text> <Tooltip title={'Ant Design, a design language for background applications, is refined by Ant UED Team.'}><EyeIcon className="sub-text" /></Tooltip>
              <Card>
                <Image src={'https://letsenhance.io/static/8f5e523ee6b2479e26ecc91b9c25261e/1015f/MainAfter.jpg'}
                    height={'300px'} />
              </Card>
            </Col>
            <Col lg={8} md={12} sm={24} xs={24} className="annoucement-block pt-4">
              <h3>
                FY'24 IBL Circular for TM-SBM-HBM <Tag>FAQ</Tag>
              </h3>
              <Typography.Text className="sub-text"
                style={{ width: 'calc(100% - 30px)' }}
                ellipsis={{ tooltip: false }}
              >
                Ant Design, a design language for background applications, is
                refined by Ant UED Team.
              </Typography.Text> <Tooltip title={'Ant Design, a design language for background applications, is refined by Ant UED Team.'}><EyeIcon className="sub-text" /></Tooltip>
              <Card>
                <div className="pdf-section">
                    <PDFICON />
                    <h4>Announcement Heading.pdf</h4>
                    <p>Employee of the month criteria for the month of July 2023</p>
                </div>
              </Card>
            </Col>
            <Col lg={8} md={12} sm={24} xs={24} className="annoucement-block pt-4">
              <h3>
                FY'24 IBL Circular for TM-SBM-HBM <Tag>FAQ</Tag>
              </h3>
              <Typography.Text className="sub-text"
                style={{ width: 'calc(100% - 30px)' }}
                ellipsis={{ tooltip: false }}
              >
                Ant Design, a design language for background applications, is
                refined by Ant UED Team.
              </Typography.Text> <Tooltip title={'Ant Design, a design language for background applications, is refined by Ant UED Team.'}><EyeIcon className="sub-text" /></Tooltip>
              <Card>
                <iframe src="https://ciplaltd-my.sharepoint.com/personal/hemant_tulsani_cipla_com/_layouts/15/embed.aspx?UniqueId=f14f7693-8258-4225-9235-d1d669a7b7fe" style={{width: '100%', height:'300px'}} height="300" frameBorder="0" scrolling="no" allowFullScreen></iframe>
              </Card>
            </Col> */}
          </Row>
        </Col>
      </Row>}
    </Fragment>
  );
}
export default AnnouncementsPage;
